import Dialog from "components/dialog";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import DynamicWebTwain from "./dynamic-web-twain.component";
import { useFlags } from "launchdarkly-react-client-sdk";
import { DIRECT_SCANNING } from "constants/feature-flags";
import { EDocumentsSourceType } from "services/types/patient-e-documents.type";

export type FolderSettings = {
  id: number;
  type: EDocumentsSourceType;
  folderId: string;
  defaultFolderDestinationPath: string;
};

type DynamicWebTwainModalProps = {
  submitButtonText: string;
  multiplePages?: boolean;
  title: string;
  folderSettings?: FolderSettings;
  onSave?: (file: File) => void;
};

const DynamicWebTwainModal: React.FC<DynamicWebTwainModalProps> = ({
  multiplePages,
  title,
  folderSettings,
  submitButtonText,
  onSave,
}) => {
  const flags = useFlags();
  const allowDirectScanning = flags[DIRECT_SCANNING];

  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  if (!allowDirectScanning) {
    return null;
  }

  return (
    <>
      <Button onClick={onOpen}>Scan</Button>
      <Dialog
        title={title}
        open={isOpen}
        onClose={onClose}
        maxWidth="lg"
        dialogContentProps={{ sx: { pb: 5 } }}
      >
        <DynamicWebTwain
          onClose={onClose}
          multiplePages={multiplePages}
          folderSettings={folderSettings}
          submitButtonText={submitButtonText}
          onSave={onSave}
        />
      </Dialog>
    </>
  );
};

export default DynamicWebTwainModal;
